export default __webpack_public_path__ + "static/media/icon-scroll.593cee62.svg";